// bookingDetails.style.js

// FlexBox styling for consistent spacing
export const flexBoxStyle = {
    display: "flex",
    justifyContent: "flex-start",
    width: "100%",
    gap: 1,
    marginTop: 1,
  };
  
  // Regular text style (No bold, adjusted size)
  export const textStyle = {
    variant: "body2",
    color: "textSecondary",
    fontSize: "0.8rem", // Slightly smaller font for labels
  };
  
  // Soften the label style (removing bold for cleaner look)
  export const labelStyle = {
    fontWeight: "normal",  // No bold font weight
    variant: "body2",
    color: "rgba(0, 0, 0, 0.6)",  // Dimmed color (adjust opacity for desired dimness)
    fontSize: "0.8rem",  // Slightly smaller font for labels
    paddingRight: "2px",  // Added padding to the right
  };
  


  // Regular text for values (keeps it standard)
  export const valueStyle = {
    variant: "body1",
    color: "textPrimary",
    fontSize: "0.8rem", // Slightly smaller font for labels
  };
  
  // Button absolute positioning with soft emphasis
  export const absoluteButtonStyle = {
    position: "absolute",
    top: "10px",
    right: "10px",
    fontWeight: "normal",  // Avoid bold here as well
  };
  
  // Description Text (cleaner for multi-line)
  export const descriptionTextStyle = {
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
    WebkitLineClamp: 2,
    lineHeight: "1.5",
    wordBreak: "break-word",
    overflowWrap: "break-word",
  };
  
  // Item Header Style: Slightly smaller for better hierarchy
  export const itemHeaderStyle = {
    variant: "subtitle2",  // Changed from subtitle1 to subtitle2 for better balance
    fontWeight: "bold",    // Keep it bold but slightly smaller
    fontSize: "1rem", 
  };
  